module.exports = __webpack_public_path__ + "img/home.e39596d0.png";